import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class RegistrationService {
  openRegistration(): void {
    window.open(environment.registrationUrl, '_blank', 'noopener,noreferrer');
  }
}
